import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getListMailGroupsWithIdProject } from 'services/api';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireSelectionEmailgroup.module.scss';

const FormulaireSelectionEmailgroup = (props) => {
  const { preconfigurerEmailgroupId, affichageProfil, gererEmailgroupId } =
    props;
  const [emailGroupId, setEmailGroupId] = useState(preconfigurerEmailgroupId);
  const [selectedValue, setSelectedValue] = useState(
    preconfigurerEmailgroupId || ''
  );

  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );

  useEffect(() => {
    const getEmailGroup = async () => {
      try {
        const response = await getListMailGroupsWithIdProject({
          list_project_id: filtre_projects_list_id,
        });
        if (response.state) {
          setEmailGroupId(response.list_emails_groups);
        }
      } catch (error) {
        console.error(error);
      }
    };
    getEmailGroup();
  }, [filtre_projects_list_id]);

  useEffect(() => {
    setSelectedValue(preconfigurerEmailgroupId || '');
  }, [preconfigurerEmailgroupId]);

  const handleChange = (event) => {
    const newEmailgroup = event.target.value;
    setSelectedValue(newEmailgroup);
    if (typeof gererEmailgroupId === 'function') {
      gererEmailgroupId(newEmailgroup);
    }
  };

  return (
    <>
      <label className={[styles.stile].join(' ')}>
        {checkMot('groupe_email')}
      </label>
      {emailGroupId?.length > 0 ? (
        <select
          className={[s.custom_select, s.mr_sm_2, styles.text_geral].join(' ')}
          onChange={handleChange}
          value={selectedValue}
          disabled={affichageProfil === true}
        >
          <option key={'TypeNull'} value="">
            {checkMot('selectionnegroupe_email')}
          </option>
          {emailGroupId.map((group) => (
            <option key={group.group_email_id} value={group.group_email_id}>
              {`${checkMot('id')}: ${group.group_email_id}, ${checkMot(
                'nom'
              )}: ${group.email_group_name}`}
            </option>
          ))}
        </select>
      ) : (
        <div>
          {' '}
          {checkMot('liste_capteur_type_pas_recupere_actualiser_page')}
        </div>
      )}
    </>
  );
};
export default FormulaireSelectionEmailgroup;
